export const colors = {
  blue: "#0000ff",
  brightGray: "#eee",
  brightNavyBlue: "#1976d2",
  cinnabar: "#eb4034",
  coralRed: "#f44336",
  lightGray: "#d3d3d3",
  maximumRed: "#d7281b",
  white: "#fff",
} as const;

export const setAlpha = (color: string, alpha: number) =>
  `${color}${Math.floor(alpha * 256).toString(16)}`;
